import Faqs from "@components/layout/main-layout/private-layout/faqs";
import { Pricing } from "@components/layout/main-layout/private-layout/pricing";
import ForgotPassword from "@components/layout/main-layout/public-layout/forgot-password";
import CheckEmail from "@components/layout/main-layout/public-layout/forgot-password/check-email";
import ResetPasswordSuccessfully from "@components/layout/main-layout/public-layout/forgot-password/reset-password-successfully";
import SetNewPassword from "@components/layout/main-layout/public-layout/forgot-password/set-new-password";
import Login from "@components/layout/main-layout/public-layout/login";
import PrivacyPolicy from "@components/layout/main-layout/public-layout/privacy-policy";
import ProjectResults from "@components/layout/main-layout/public-layout/project-result/ProjectResults";
import Signup from "@components/layout/main-layout/public-layout/signup";
import VerifyEmail from "@components/layout/main-layout/public-layout/signup/verify-email";
import SoftwareAttribution from "@components/layout/main-layout/public-layout/software-attribution";
import TermOfUse from "@components/layout/main-layout/public-layout/term-of-use";
import DataSecurityAssurance from "@components/layout/main-layout/public-layout/data-security-agreement";
import StartingPage from "@components/layout/main-layout/public-layout/welcome-screen";
import ExistingProject from "@components/pages/ExistingProject/existingProject";
import SuperAdminLogin from "@components/pages/SuperAdmin/SuperAdminLogin";
import Home from "@components/pages/home";
import Playground from "@components/pages/project/Playground/Playground";
import AdvisorPage from "@components/pages/project/single-functions/project-structuring/main-page";
import { DraftPage } from "@components/pages/project/single-functions/refine-a-cn/main-page";
import GradePage from "@components/pages/project/single-functions/evaluate-a-cn/main-page";
import GradeWelcome from "@components/pages/project/single-functions/evaluate-a-cn/welcome-page/GradeWelcome";
import ProjectStructureWelcome from "@components/pages/project/single-functions/project-structuring/welcome-page/ProjectStructureWelcome";
import RationalAdvisorPage from "@components/pages/project/single-functions/climate-rationale-advisor/main-page";
import RationalAdvisorWelcome from "@components/pages/project/single-functions/climate-rationale-advisor/welcome-page/RationalAdvisorWelcome";
import SelectDonor from "@components/pages/project/select-donor";
import SelectFunction from "@components/pages/project/select-function";
import ProjectName from "@components/pages/project/project-name";
import GCFCongratulation from "@components/common-components/gcf-congratulation";
import SelectFunder from "@components/pages/project/select-funder";
import TheoryOfChangePage from "@components/pages/project/single-functions/theory-of-change/main-page";
import TheoryOfChangeWelcome from "@components/pages/project/single-functions/theory-of-change/welcome-page/TheoryOfChangeWelcome";
import { constRoute } from "@utils/route";
import { memo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NoObjectionProcedurePage from "@components/pages/project/single-functions/no-objection-procedure/main-page";
import SelectEvaluateMode from "@components/pages/project/single-functions/evaluate-a-cn/select-mode";
import QuickAssessment from "@components/pages/project/single-functions/evaluate-a-cn/quick-assessment-page";
import CNConverterWelcome from "@components/pages/project/single-functions/cn-converter/welcome-page/CNConverterWelcome";
import CNConverterProject from "@components/pages/project/single-functions/cn-converter/main-page";

const Routing = () => {
  return (
    <>
      <Routes>
        <Route
          path={constRoute?.draftProject + "/:type/:step"}
          element={<DraftPage />}
        />
        <Route
          path={constRoute?.gradeProject + "/:type/:step"}
          element={<GradePage />}
        />
        <Route
          path={constRoute?.gradeProject + "/quick"}
          element={<QuickAssessment />}
        />
        <Route
          path={constRoute?.advisorProject + "/:type/:step"}
          element={<AdvisorPage />}
        />
        <Route
          path={constRoute?.rationalAdvisorProject + "/:type/:step"}
          element={<RationalAdvisorPage />}
        />
        <Route
          path={constRoute?.theoryOfChangeProject + "/:type/:step"}
          element={<TheoryOfChangePage />}
        />
        <Route
          path={constRoute?.noObjectionProcedureProject + "/:type/:step"}
          element={<NoObjectionProcedurePage />}
        />

        <Route
          path={constRoute?.cnConverterProject}
          element={<CNConverterProject />}
        />
        <Route path={constRoute?.projectResult} element={<ProjectResults />} />
        <Route path={constRoute?.root} element={<StartingPage />} />
        <Route path={constRoute?.login} element={<Login />} />
        <Route path={constRoute?.signup} element={<Signup />} />
        <Route path={constRoute?.forgetPassword} element={<ForgotPassword />} />
        <Route path={constRoute?.checkEmail} element={<CheckEmail />} />
        <Route path={constRoute?.setNewPassword} element={<SetNewPassword />} />
        <Route
          path={constRoute?.resetPasswordSuccessfully}
          element={<ResetPasswordSuccessfully />}
        />
        <Route path={constRoute?.verifyEmail} element={<VerifyEmail />} />
        <Route path={constRoute?.home} element={<Home />} />
        <Route path={constRoute?.faqs} element={<Faqs />} />
        {/* DISABLE PLAYGROUND*/}
        {/*<Route path={constRoute?.playground} element={<Playground />} />*/}
        <Route path={constRoute?.selectFunder} element={<SelectFunder />} />
        <Route path={constRoute?.selectDonor} element={<SelectDonor />} />
        <Route path={constRoute?.selectFunction} element={<SelectFunction />} />
        <Route
          path={constRoute?.projectStructureWelcome}
          element={<ProjectStructureWelcome />}
        />
        <Route path={constRoute?.gradeWelcome} element={<GradeWelcome />} />
        <Route
          path={constRoute?.cnConverterWelcome}
          element={<CNConverterWelcome />}
        />
        <Route
          path={constRoute?.gradeSelectMode}
          element={<SelectEvaluateMode />}
        />
        <Route
          path={constRoute?.theoryOfChangeWelcome}
          element={<TheoryOfChangeWelcome />}
        />
        <Route
          path={constRoute?.rationalAdvisorWelcome}
          element={<RationalAdvisorWelcome />}
        />
        <Route
          path={constRoute?.masteradminLogin}
          element={<SuperAdminLogin />}
        />
        <Route
          path={constRoute?.projectName + "/:type"}
          element={<ProjectName />}
        />
        <Route
          path={constRoute?.gcfCongratulation + "/:type"}
          element={<GCFCongratulation />}
        />
        <Route
          path={constRoute?.existingProject}
          element={<ExistingProject />}
        />
        <Route
          path={constRoute?.DataSecurityAssurance}
          element={<DataSecurityAssurance />}
        />
        <Route path={constRoute?.TermOfUse} element={<TermOfUse />} />
        <Route path={constRoute?.privacyPolicy} element={<PrivacyPolicy />} />
        <Route
          path={constRoute?.softwareAttribution}
          element={<SoftwareAttribution />}
        />
        <Route path={constRoute?.pricing} element={<Pricing />} />

        <Route path="*" element={<Navigate to={constRoute.home} replace />} />
      </Routes>
    </>
  );
};
export default memo(Routing);
